import React from 'react';

import {Paper, Typography} from 'views/components';
import {Translate} from 'views/module';

const TitleCard = () => {
  return (
    <Paper
      sx={{
        p: '24px',
        borderRadius: '20px',
        boxShadow: 'none',
      }}
    >
      <Typography sx={{fontSize: '32px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif', mb: '20px'}}>
        <Translate expression={'schedulestep.TitleCard.Title'} />
      </Typography>

      <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925', lineHeight: '150%'}}>
        <Translate expression={'schedulestep.TitleCard.Description'} />
      </Typography>
    </Paper>
  );
};

export default React.memo(TitleCard);
